module.exports = __webpack_public_path__ + "img/sword-laser.0458b08f.svg";